import {DataTransferObject} from './DataTransferObject';

export abstract class PaymentInfoDTO extends DataTransferObject {
  abstract validate(): boolean;
  abstract validateField(field: string): boolean;
}
